import type { CSSObject } from "@emotion/serialize";

export const popOverShadow = (): CSSObject => ({
  boxShadow: "0 4px 10px 0 rgba(0, 0, 0, 0.1)",
});

export const inputFieldShadow = (): CSSObject => ({
  boxShadow: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.04)",
});

export const basicFocusShadow = (): CSSObject => ({
  boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.06)",
});
